"use client";
import SectionHeading from "../shared/SectionHeading";
const CareerOpportunity = ({ data }) => {
  const styles = {
    background: `
          radial-gradient(circle at 100% 100%, #ffffff 0, #ffffff 8px, transparent 8px) 0% 0%/10px 10px no-repeat,
          radial-gradient(circle at 0 100%, #ffffff 0, #ffffff 8px, transparent 8px) 100% 0%/10px 10px no-repeat,
          radial-gradient(circle at 100% 0, #ffffff 0, #ffffff 8px, transparent 8px) 0% 100%/10px 10px no-repeat,
          radial-gradient(circle at 0 0, #ffffff 0, #ffffff 8px, transparent 8px) 100% 100%/10px 10px no-repeat,
          linear-gradient(#ffffff, #ffffff) 50% 50%/calc(100% - 4px) calc(100% - 20px) no-repeat,
          linear-gradient(#ffffff, #ffffff) 50% 50%/calc(100% - 20px) calc(100% - 4px) no-repeat,
          linear-gradient(90deg, #ff9900 0%, #04236b 100%)
        `,
    borderRadius: "10px",
    boxSizing: "border-box",
  };

  if (!data.section[6].isActive) {
    return <div></div>;
  }

  return (
    <div className="my-12 mx-auto max-w-[1500px] px-4">
      <SectionHeading>
        <span className="text-primary-color">Career</span>{" "}
        <span className="text-secondary-color">Opportunities</span>
      </SectionHeading>
      <div className="mt-10 flex flex-wrap justify-center gap-3 sm:gap-4">
        {/* Responsive card layout with icons */}
        {data.section[6].list1.map((item, index) => (
          <div
            key={index}
            className="flex items-center w-full sm:w-[270px] md:w-[320px] lg:w-[340px] xl:w-[370px] min-h-[56px] bg-white border border-[#e0e7ff] rounded-xl shadow-sm px-4 py-3 mb-2 hover:shadow-md transition-all duration-200 gap-3"
            style={{
              background:
                'linear-gradient(90deg, #fff 80%, #f7fafc 100%)',
              boxSizing: 'border-box',
            }}
          >
            {/* Icon - alternate icons for variety */}
            <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[#f0f4ff] border border-[#e0e7ff] mr-2">
              {index % 3 === 0 && (
                // Briefcase
                <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="#04236B" strokeWidth="1.7"><rect x="3" y="7" width="18" height="13" rx="2.5"/><path d="M16 7V5a4 4 0 0 0-8 0v2"/><path d="M3 13h18"/></svg>
              )}
              {index % 3 === 1 && (
                // Chart
                <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="#FF9900" strokeWidth="1.7"><rect x="3" y="13" width="4" height="6" rx="1.5"/><rect x="9" y="9" width="4" height="10" rx="1.5"/><rect x="15" y="5" width="4" height="14" rx="1.5"/></svg>
              )}
              {index % 3 === 2 && (
                // Graduation cap
                <svg width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="#04236B" strokeWidth="1.7"><path d="M3 7l9-4 9 4-9 4-9-4z"/><path d="M21 10v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6"/><path d="M7 17v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2"/></svg>
              )}
            </span>
            <span className="text-[15px] text-[#262626] font-medium text-left break-words">
              {item.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CareerOpportunity;
